export default __webpack_public_path__ + "static/media/clay_phone_13_pro_max_mockup.2e71c95a.png";